module.exports = __webpack_public_path__ + "img/tudomudanumgiro.504e8eae.png";